export function jqReadMoreModalBehavior() {
  $('#readMoreModal').on('show.bs.modal', function (event) {
    // @ts-ignore
    const button = $(event.relatedTarget) // relatedTarget is not allowed :/
    const contentID = button.data('content')
    const content = $(`#${contentID}`).html()
    $(this).find('.modal-body').html(content)
  })
}
